var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`page-container overflow-y-auto flex-grow ${_vm.isFullscreen ? 'flex-fullscreen' : ''}`},[_c('div',{class:`section ${_vm.isFullscreen ? 'flex-fullscreen' : ''}`},[_c('div',{class:`container w-full ${_vm.isFullscreen ? 'flex-fullscreen' : ''}`},[(_vm.isLoading)?_c('Loading'):(_vm.error)?_c('Error'):_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }